import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function StaffLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate(user.role === "admin" ? "/admin" : "/driver", { replace: true });
  }, [user]); // eslint-disable-line

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const data = await login(email, password);
      navigate(data.role === "admin" ? "/admin" : "/driver", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#08080C]">
      <div className="w-full max-w-sm fade-up">
        <button onClick={() => navigate("/")} className="text-slate-500 hover:text-amber-400 text-sm mb-6 inline-flex items-center gap-1">
          <ArrowLeft className="w-4 h-4" /> Catalogue
        </button>
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <Sparkles className="w-6 h-6 text-slate-950" />
          </div>
          <h1 className="text-3xl font-bold gold-text">Avenue Benda</h1>
          <p className="text-xs font-mono uppercase tracking-widest text-amber-400/60 mt-1">Espace Vendeur & Livreur</p>
        </div>
        <form onSubmit={submit} className="glass rounded-2xl p-6 space-y-4">
          <div>
            <Label className="text-slate-300 text-xs">Email</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-[#161926] border-amber-500/20 mt-1 text-slate-100" required />
          </div>
          <div>
            <Label className="text-slate-300 text-xs">Mot de passe</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-[#161926] border-amber-500/20 mt-1 text-slate-100" required />
          </div>
          {error && <p data-testid="login-error" className="text-rose-400 text-sm">{error}</p>}
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full btn-gold rounded-xl py-6">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
